import type {
  CreateScheduledPostBody,
  ScheduledPostResponse,
} from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function createScheduledPost(
  body: CreateScheduledPostBody,
): Promise<ScheduledPostResponse> {
  return apiClient.url("/social-publishing/scheduled-posts").post(body).json();
}

export function useCreateScheduledPost(): UseMutationResult<
  ScheduledPostResponse,
  { message?: string },
  CreateScheduledPostBody
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createScheduledPost,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: socialPublishingKeys.scheduledPosts(),
      });
    },
  });
}
